import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { applyBrand } from "@/lib/api";

const AuthContext = createContext(null);

export const homePath = (role) =>
  role === "super_admin" ? "/admin"
    : role === "company_admin" ? "/dashboard"
    : role === "gestoria" ? "/documents"
    : "/portal";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data?.company?.primary_color) applyBrand(data.company.primary_color);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    if (data.user?.company_id) await refresh();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
    applyBrand("#003366");
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
